import React, { forwardRef, useEffect, useState } from 'react';

import { Input } from '@vlabs/uikit/components/controls/input';
import { useTranslation } from 'react-i18next';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useSourceFilters } from '../useSourceFilters';

function ReferenceFilterPopover(
  {
    ...props
  }: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useTranslation();
  const [localValue, setLocalValue] = useState<string>('');
  const { filters, updateFilters } = useSourceFilters();

  useEffect(() => {
    setLocalValue(filters.reference ?? '');
  }, [filters.reference]);

  const onChangeHandler = (reference: string) => {
    setLocalValue(reference);

    if (reference) {
      updateFilters({ reference, page: 1 });
    } else {
      updateFilters({ reference: undefined, page: 1 });
    }
  };

  const reset = () => {
    setLocalValue('');
    updateFilters({ reference: undefined, page: 1 });
  };

  return (
    <PopoverWithButton
      {...props}
      data-testid="stream-reference"
      onClickReset={reset}
      ref={ref}
      title={<div className="Body-2">{t('entities:source_filters.reference.popover_title')}</div>}
    >
      <Input
        isClearable
        onChangeValue={onChangeHandler}
        onClear={reset}
        placeholder={t('entities:source_filters.reference.placeholder') as unknown as string}
        value={localValue}
      />
    </PopoverWithButton>
  );
}

export default forwardRef(ReferenceFilterPopover);
